import React from 'react'
import {youtube} from './youtube-data'

import './Youtube.scss'

const Youtube = ({romana}: { romana: boolean }) =>
    <div className="bg-white">
        <div id="live" className="youtube">
            <div>
                <iframe frameBorder="0" allowFullScreen={true}
                        src="https://www.youtube.com/embed/live_stream?channel=UCxBofq4UIEiwXEgp3yerJRQ"/>
            </div>
            <div>
                <p className="youtube-subtitle">{romana ? youtube['subtitle-ro'] : youtube['subtitle-de']}</p>
                <h1 className="youtube-header">{romana ? youtube['header-ro'] : youtube['header-de']}</h1>
                <p className="youtube-text">{romana ? youtube['text-ro'] : youtube['text-de']}</p>
                <a href="https://www.youtube.com/user/agapewien/videos"
                   className="youtube-button">{romana ? youtube['button-ro'] : youtube['button-de']}</a>
            </div>
        </div>
    </div>


export default Youtube
